import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button } from '@material-ui/core';
import { Typography } from '@orijinworks/frontend-commons';
import { getPlanTypeSwitcherCopy } from '../../../../utils/case-plan-create.util';
import SectionTitle from '../SectionTitle';
import PlanTypeCard from './PlanTypeCard';
import { usePlanTypeSectionStyles } from './PlanTypeSection.styles';

/**
 * Feature flag for the resident/template switcher.
 * Exported as a mutable object so unit tests can toggle it without rewiring modules.
 * Temporarily false until create-template flow is ready.
 */
export const planTypeSectionFlags = {
  showSwitcher: false,
};

/**
 * Plan Type section with resident/template card and type switcher link.
 * Styles match Figma Plan Type (967:20240 / 967:31116).
 */
export const PlanTypeSection = ({ planType, onSwitchPlanType }) => {
  const classes = usePlanTypeSectionStyles();

  if (!planType) {
    return null;
  }

  const switcherCopy = planTypeSectionFlags.showSwitcher
    ? getPlanTypeSwitcherCopy(planType)
    : null;

  return (
    <Box className={classes.root}>
      <SectionTitle title="Plan Type" />
      <PlanTypeCard
        name={planType.name}
        description={planType.description}
        planTypeKey={planType.key}
      />
      {switcherCopy ? (
        <Box className={classes.switcher}>
          <Typography variant="body1" className={classes.switcherText}>
            {switcherCopy.prompt}
          </Typography>
          <Button
            className={classes.createTemplateButton}
            onClick={onSwitchPlanType}
            disableRipple
          >
            {switcherCopy.actionLabel}
          </Button>
        </Box>
      ) : null}
    </Box>
  );
};

PlanTypeSection.propTypes = {
  planType: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
  onSwitchPlanType: PropTypes.func,
};

PlanTypeSection.defaultProps = {
  planType: null,
  onSwitchPlanType: undefined,
};

export default PlanTypeSection;
